import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _13mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"13mp"}/>
}
